import PropTypes from 'prop-types'

import TextAreaField from '../../../../FormLegacy/FormFieldsV2/TextAreaField'

import FormInput from './FormInput'

const TextareaInput = ({
  columnSize,
  name,
  label,
  placeholder,
  value,
  setFieldValue,
  helperText,
  maxLength = 1000,
}) => {
  return (
    <div className={`column is-${columnSize}`}>
      <FormInput label={label} name={name} className="event-description-textarea">
        <>
          <TextAreaField
            name={name}
            onChange={(e) => setFieldValue(name, e.target.value)}
            value={value}
            placeholder={placeholder}
            maxLength={maxLength}
          />
          {helperText && <p className="event-form-input-helper-text">{helperText}</p>}
        </>
      </FormInput>
    </div>
  )
}

TextareaInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  maxLength: PropTypes.number,
}

export default TextareaInput
